import { Loader } from "@/components/layout/DefaultLayout";
import { CSSProperties, FC } from "react";

export const FullScreenLoader: FC = () => {
  const style: CSSProperties = {
    position: 'fixed',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }

  return (
    <div style={style}>
      <Loader spinning size={'large'} />
    </div>
  )
}